import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {
  ICancelatioReason
} from '@literax/models/http/document/document.model';
import { Store, select } from '@ngrx/store';

import { ISignatureResponse } from '@literax/models/http/api/signature.model';
import { IUser } from '@literax/models/user.model';
import { selectCommentRejected } from '@literax/modules/documents/store/document/document.selectors';
import { ISignRequest } from '@literax/modules/documents/store/document/document.state';
import { selectPromissoryNote } from '@literax/modules/promissory-notes/store/promissory-notes.selector';
import { IAppState } from '@literax/store';


import { IDocumentResponse } from '@literax/models/document.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { selectPromissoryNoteV3 } from '../../promissory-notes/store/promissory-notes.selector';
@UntilDestroy()
@Component({
  selector: 'literax-signed-list-container',
  templateUrl: './signed-list-container.component.html',
  styleUrls: ['./signed-list-container.component.scss']
})
export class SignedListContainerComponent implements OnInit {
  @Input() document: IDocumentResponse;
  @Input() signerRequest: ISignRequest[];
  @Input() typePromissoryNote: boolean;
  @Input() hasObservers: boolean;
  @Input() hasSigner: boolean;
  @Output() addSigner: EventEmitter<void> = new EventEmitter<void>();
  @Output() signatureAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() historyButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() configPromissoryNote: EventEmitter<any> = new EventEmitter<any>();
  @Input() user: IUser;
  @Input() forceEnabledButton: boolean;
  contentVisible = true;
  signatures: { [key: string]: ISignatureResponse } = {};

  isUserLoginObserver = false;
  participantsPromissoryNote: Partial<ISignRequest[]> = [];

  // promissoryNote$ = this.store.pipe(
  //   untilDestroyed(this),
  //   select(selectPromissoryNote)
  // );

    promissoryNoteV3$ = this.store.pipe(
    untilDestroyed(this),
    select(selectPromissoryNoteV3)
  );

  comment$ = this.store.pipe(
    untilDestroyed(this),
    select(selectCommentRejected)
  );
  comment: ICancelatioReason[];

  constructor(private store: Store<IAppState>) {}

  ngOnInit(): void {
    // if (this.document && this.document.signatures) {
    //   this.document.signatures.forEach((s) => (this.signatures[s.rfc] = s));
    // }
    this.finUserObserver(this.document.signRequests.observers);

    if (
      this.typePromissoryNote &&
      (this.document.status.key === 'signed' ||
        this.document.status.key === 'in_effect' ||
        this.document.status.key === 'expired' ||
        this.document.status.key === 'extinc')
    ) {
      this.getPromissoryNoteParticipant();
    }
    this.comment$
      .pipe(untilDestroyed(this))
      .subscribe((reason) => (this.comment = reason));
  }


  toggleTabContent() {
    this.contentVisible = !this.contentVisible;
  }

  finUserObserver(observers) {
    // observers.find((observer) => {
    //   this.isUserLoginObserver = observer.email === this.user.email;
    // });
  }

  getPromissoryNoteParticipant() {
    // this.promissoryNote$.pipe().subscribe((data) => {
    //   if (data) {
    //     this.participantsPromissoryNote = data?.participants;
    //   }
    // });

    this.promissoryNoteV3$.pipe().subscribe((data) => {
      if (data) {
        this.participantsPromissoryNote = data?.participants.map(participant => ({
          is_author: this.document.signRequests.naturalPersons.some(signatory => signatory.email === participant.email && signatory.isAuthor) || this.document.signRequests.legalPersons.some(signatory => signatory.email === participant.email && signatory.isAuthor),
          email: participant.email,
          name: participant.name,
          rfc: participant.rfc,
          signatory_role: { id: null, created_at: null, updated_at: null,  name: participant.signatoryRole.name },
          company_name: participant.companyName,
          company_rfc: participant.companyRfc,
          signature_type_name: participant.signatureTypeName,
          holder_status: participant.holderStatus
        }));
      }
    });
  }
}
